<template>
  <div class="menu-container">
    <el-menu
      ref="menu"
      @select="selectHandler"
      :default-active="defaultActive"
      mode="horizontal"
      text-color="#fff"
      active-text-color="#1E4A7C"
      background-color="#1E4A7C"
    >
      <el-menu-item style="font-size: 20px;height: 100%;line-height: 35px" index="/index">首页</el-menu-item>
      <template v-for="(item,index) in menu">
        <el-menu-item
          :index="item.href"
          :key="item.id"
          v-if="!item.children||!item.children.length"
        >{{item.label}}</el-menu-item>
        <el-menu-item
          :index="item.children[0].href"
          style="font-size: 20px;height: 100%;line-height: 35px"
          :key="item.id"
          v-else-if="item.children&&item.children.length===1"
        >
          <span>{{item.label}}</span>
        </el-menu-item>
        <template v-else>
          <el-submenu :index="index.toString()">
            <span slot="title">{{item.label}}</span>
            <template v-for="(menu,i) in item.children">
              <el-menu-item
                :key="menu.id"
                v-if="!menu.children||!menu.children.length"
                :index="menu.href"
              >{{menu.label}}</el-menu-item>
              <menu-item :index="index+'-'+i" v-else :route="menu.children" :key="menu.id"></menu-item>
            </template>
          </el-submenu>
        </template>
      </template>
    </el-menu>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import menuItem from "./menu-item";
export default {
  name: "customMenu",
  data() {
    return {
      defaultActive: ""
    };
  },
  components: {
    customMenuItem: menuItem
  },
  methods: {
    selectHandler(e) {
      this.$router.push({ path: e });
    }
  },
  computed: {
    ...mapGetters(["menu"])
  },
  watch: {
    $route: function(v) {
      if (v) {
        this.defaultActive = v.path;
      }
    }
  },
  mounted() {
    let { path } = this.$route;
    for (let i = 0; i < this.menu.length; i++) {
      if (this.menu[i].children && this.menu[i].children.length) {
        for (let m of this.menu[i].children) {
          if (m.href === path) {
            this.defaultActive = m.href;
            break;
          }
        }
        if (this.defaultActive) {
          break;
        }
      } else if (this.menu[i].href === path) {
        this.defaultActive = this.menu[i].href;
        break;
      }
    }
    // console.log(this.menu);
  }
};
</script>
